import React from 'react'
import { apiGet, apiDownloadFile } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { IconButton } from '@mui/material'
import Ok from '../../../images/OK.png'
import NoOk from '../../../images/NO_OK.png'
import { PictureAsPdfRounded } from '@mui/icons-material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import useRepositorySelection from '../../generic/hooks/useRepositorySelection'
import { parentPreselectedRecordFrom } from '../../generic/utilities/repositorySelectionMapping'

const imgStyle = {
  verticalAlign: 'middle',
  height: '1.8rem',
  width: '1.8rem'
}

const Inspection = () => {
  const { t_ } = useSmartTranslation()
  // Historia 170 (J4b, S89): INSPECTION_REPORT has no child window in the Gherkin contract.
  const repositorySelection = useRepositorySelection()

  const columns = [
    {
      name: t_('Part Code'),
      field: 'partCode'
    },
    {
      name: t_('Part Reference'),
      field: 'partReferenceName'
    },
    {
      name: t_('Name'),
      field: 'reportName'
    },
    {
      name: t_('Asset'),
      field: 'deviceName'
    },
    {
      name: t_('Date'),
      field: 'reportDate',
      type: 'datetime'
    },
    {
      name: t_('Result'),
      field: 'inspectionResult',
      render: (rowData) => (
        <img
          style={imgStyle}
          src={rowData.inspectionResult === 'OK' ? Ok : NoOk}
          alt=''
        />
      )
    }
  ]

  const actions = {
    custom: [
      {
        name: 'Download',
        render: (inspection) => (
          <IconButton>
            <PictureAsPdfRounded />
          </IconButton>
        ),
        onClick: async (inspection) => {
          if (!inspection.id) return
          try {
            const fileName = inspection?.reportName ?? `${inspection.partReferenceName}_${inspection.partCode}_report.pdf`
            await apiDownloadFile('inspectionReports/' + inspection.id, fileName, null)
          } catch (error) {
            console.error('Error downloading file:', error)
          }
        }
      }
    ]
  }

  const sortOptions = [{
    field: 'reportDate',
    direction: -1
  }]

  const fetchFunction = async (pagination) => {
    return await apiGet('inspectionReports', pagination)
  }

  const title = t_('Inspection')

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='inspect'
      columns={columns}
      title={title}
      dataFetch={fetchFunction}
      actions={actions}
      pageable
      preselectedRecord={parentPreselectedRecordFrom(repositorySelection)}
      sortOptions={sortOptions}
    />
  )
}

export default Inspection
